import { render, staticRenderFns } from "./StorePopup.vue?vue&type=template&id=5031ecfa&"
import script from "./StorePopup.vue?vue&type=script&lang=js&"
export * from "./StorePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports